import React, { useEffect, useRef, useState } from 'react';
import { Container } from './styles';

interface AiManagementAddColumnProps {
  onCreate: (name: string) => void;
}

const AiManagementAddColumn: React.FC<AiManagementAddColumnProps> = ({ onCreate }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  const close = () => {
    setName('');
    setOpen(false);
  };

  const create = () => {
    const trimmed = name.trim();
    if (trimmed) onCreate(trimmed);
    setName('');
    inputRef.current?.focus();
  };

  const keepFocus = (event: React.MouseEvent) => event.preventDefault();

  if (!open) {
    return (
      <Container className="flex-shrink-0 align-self-start">
        <button
          type="button"
          className="btn btn-light border text-muted d-flex align-items-center justify-content-center w-100"
          onClick={() => setOpen(true)}
        >
          <i className="material-icons mr-1">add</i>
          Adicionar coluna
        </button>
      </Container>
    );
  }

  return (
    <Container className="flex-shrink-0 align-self-start bg-white border rounded p-2">
      <input
        ref={inputRef}
        type="text"
        className="form-control"
        placeholder="Digite o nome da coluna"
        aria-label="Nome da coluna"
        value={name}
        onChange={(event) => setName(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') create();
          if (event.key === 'Escape') close();
        }}
        onBlur={() => {
          if (!name.trim()) close();
        }}
      />
      <div className="d-flex align-items-center mt-2">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onMouseDown={keepFocus}
          onClick={create}
        >
          Adicionar coluna
        </button>
        <button
          type="button"
          className="btn btn-link text-secondary p-0 ml-3 d-flex align-items-center"
          aria-label="Cancelar"
          onMouseDown={keepFocus}
          onClick={close}
        >
          <i className="material-icons">close</i>
        </button>
      </div>
    </Container>
  );
};

export default AiManagementAddColumn;
